import { render, staticRenderFns } from "./ContentSnippet.vue?vue&type=template&id=4f08ea31&"
import script from "./ContentSnippet.vue?vue&type=script&lang=js&"
export * from "./ContentSnippet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports